import React from "react";
import { Navbar } from '@themesberg/react-bootstrap';

export default (props) => {
  return (
    <Navbar variant="dark" expanded className="ps-0 pe-2 pb-0">
     
    </Navbar>
  );
};
